<template>
  <div>
    <div class="d-flex justify-end align-center ma-6">
      <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
        <v-icon left>mdi-file-excel</v-icon> Xuất Excel
      </v-btn>
      <v-btn
        v-if="$auth.policies['add-new-attendance']"
        class="ml-6"
        @click="checkinState = !checkinState"
        dark
        color="#0D47A1"
      >
        <v-icon left>add</v-icon>Thêm điểm danh
      </v-btn>
    </div>
    <v-card outlined class="pa-6 mx-6 mb-6 elevation-0">
      <BoardingClassAttendanceFilter ref="attendance-filter" @onFilterChanged="refresh" />
    </v-card>
    <v-card outlined class="mx-6 mb-6 elevation-0">
      <BoardingClassAttendanceDataTable ref="table" />
    </v-card>
    <AddBoardingClassAttendanceDialog :state="checkinState" @attendanceAdded="refresh(searchParams)" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { BoardingClassSessionAttendance } from '@/plugins/api'
import { get } from 'lodash'
import moment from 'moment'
import utils from '@/plugins/utils'
import BoardingClassAttendanceFilter from './components/BoardingClassAttendanceFilter'
import BoardingClassAttendanceDataTable from './components/BoardingClassAttendanceDataTable'
import AddBoardingClassAttendanceDialog from './components/AddBoardingClassAttendanceDialog'

export default {
  data() {
    return {
      checkinState: false,
      menu: false,
      date: moment().format('YYYY-MM-DD')
    }
  },
  components: {
    BoardingClassAttendanceFilter,
    BoardingClassAttendanceDataTable,
    AddBoardingClassAttendanceDialog
  },
  computed: {
    ...mapState('boardingClassAttendance', ['searchParams', 'attendanceStudentSearchParams'])
  },
  mounted() {
    this.$refs['attendance-filter'].onFilterChanged()
  },
  methods: {
    ...mapActions('boardingClassAttendance', ['getAttendanceStudents', 'getManyAttendances']),
    refresh(query) {
      this.$refs.table.searchAttendances(query)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.table.$data.headers]
        headers.splice(1, 0, { text: 'Mã số', value: 'code' })
        let excelHeader = headers
          .map(({ text, value }) => ({ text, value }))
          .filter(excel => excel.value !== 'dob' && excel.value !== 'action')

        const filters = this.$options.filters

        const params = { ...this.attendanceStudentSearchParams }
        delete params['_start']
        delete params['_limit']
        params['_sort'] = 'studentNameToNumber:ASC'

        const studentCheckins = await BoardingClassSessionAttendance.fetch({ ...params, _limit: -1 })
        const attendances = JSON.parse(JSON.stringify(studentCheckins))

        const data = attendances.map(item => {
          item.code = filters.getStudentCode(item.student.code)
          item.class = get(item, 'class.title')
          item.student = get(item, 'student.name')

          let timeList = ['--', '--']
          let status = filters.getAttendanceStatus(item.status)
          if (item.checkins) {
            const timeCheckIn = get(item.checkins, '0.checkIn')
            const timeCheckOut = get(item.checkins, '0.checkOut')
            if (timeCheckIn) timeList[0] = filters.hhmm(timeCheckIn)
            if (timeCheckOut) timeList[1] = filters.hhmm(timeCheckOut)
          }
          item.time = timeList.join(' / ')
          item.status = status
          return item
        })

        const filename = `DanhSachDiemDanh-${moment().format('DD-MM-YYYY')}`
        utils.exportExcel(data, excelHeader, filename)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style></style>
